import { isArray, find, merge, sortBy } from 'lodash';
import Link from '@/models/Link';

export default class LinksCollection {
  constructor(data, parent = null) {
    this.listValues = [];
    this.parent = parent;
    this.list(data);
  }

  list(data) {
    if (isArray(data) && data.length > 0) {
      this.listValues = data.map((datum) => {
        const newDatum = merge({ parent: this.parent }, datum);
        return new Link(newDatum);
      });
    }
    return this.listValues;
  }

  sortedList(field = 'sortOrder') {
    const sorted = sortBy(this.listValues, item => item[field]());
    return sorted;
  }

  find(slug) {
    return find(this.list(), link => link.slug() === slug);
  }
}



// WEBPACK FOOTER //
// ./src/models/LinkCollection.js